<template>
  <div class="registration-expired">
      <img src="/assets/images/link-expired.svg" alt="" class="expired-icon"/>
      <h1 class="title">{{ $t('registration.registrationExpired.title') }}</h1>
      <p v-if="changeEmail" class="subtitle">{{ $t('emailChangeExpired.subtitle') }}</p>
      <p v-else class="subtitle">{{ $t('registration.registrationExpired.subtitle') }}</p>
      <base-button v-if="changeEmail" class="expired-button" @click="backToPortal" :loading="dataLoading">{{ $t('login.loginForm.loginBtn') }}</base-button>
      <base-button v-else class="expired-button" @click="backToPortal" :loading="dataLoading">{{ $t('registration.registrationExpired.register') }}</base-button>
  </div>
</template>

<script>
import { customRouter } from '@/customRouter'
import { lsGet, lsRemove } from '@/utils/localStorageController'

export default {
  name: 'page-registration-link-expired',
  data () {
    return {
      dataLoading: false,
      changeEmail: false
    }
  },
  methods: {
    backToPortal () {
      this.dataLoading = true
      if (this.changeEmail) {
        customRouter.goTo({ name: 'login' })
      } else {
        customRouter.goTo({ name: 'registration' })
      }
    }
  },
  mounted () {
    if (lsGet('sc_TokenExpired')) {
      this.changeEmail = true
      lsRemove('sc_changeEmailVerification')
    }
  }
}
</script>

<style scoped lang="scss">
.registration-expired {
  margin: 0 auto;
  width: 100%;
  max-width: 68rem;
  background-color: $white;
  border-radius: 5px;
  text-align: center;
  padding: 4rem;

  @media (map_get($breakpoints, sm)) {
    margin-top: 13rem;
  }

  @media (map_get($breakpoints, md)) {
    margin-top: 16rem;
    max-width: 84rem;
  }

  .title {
    font-size: 3.2rem;
    font-weight: normal;
    margin-top: 2.4rem;
    margin-bottom: 4rem;
    color: $text;
  }

  .subtitle {
    color: $text-alt;
    margin-bottom: 40px;
  }

  .expired-button {
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      width: auto;
    }
  }
}
</style>
